import {
    CREATE_BANK_MASTER_FAILURE,
    CREATE_BANK_MASTER_REQUEST,
    CREATE_BANK_MASTER_SUCCESS,
    CREATE_USER_FORM_BANK_MASTER,
    FETCH_BANK_MASTER_FAILURE,
    FETCH_BANK_MASTER_REQUEST,
    FETCH_BANK_MASTER_SUCCESS,
    FETCH_SINGLE_BANK_MASTER_FAILURE,
    FETCH_SINGLE_BANK_MASTER_REQUEST,
    FETCH_SINGLE_BANK_MASTER_SUCCESS,
    BANK_MASTER_USERFORM_RESET,
    UPDATE_BANK_MASTER_REQUEST,
    UPDATE_BANK_MASTER_SUCCESS,
    UPDATE_BANK_MASTER_FAILURE,
    DELETE_BANK_MASTER_REQUEST,
    DELETE_BANK_MASTER_SUCCESS,
    DELETE_BANK_MASTER_FAILURE,
    FETCH_BANK_LIST_FROM_BANK_MASTER_SUCCESS,
    FETCH_BANK_LIST_FROM_BANK_MASTER_REQUEST,
    FETCH_BANK_LIST_FROM_BANK_MASTER_FAILURE
} from './bankMaster.actionsType';

export const BANK_MASTER = 'bankMaster';

let initialState = {
    loading: false,
    bankMaster: [],
    userform: {},
    bankList: [],
    selectedBank: {},
    errorMessage: '',
    iperrorMessage: ''
};

export let bankMasterReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_BANK_MASTER_REQUEST:
        case FETCH_BANK_LIST_FROM_BANK_MASTER_REQUEST:
        case CREATE_BANK_MASTER_REQUEST:
        case FETCH_SINGLE_BANK_MASTER_REQUEST:
        case UPDATE_BANK_MASTER_REQUEST:
        case DELETE_BANK_MASTER_REQUEST:
            return {
                ...state,
                loading: true
            };

        case FETCH_BANK_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                bankMaster: updatePayload
            };
        case CREATE_BANK_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {}
            };
        case FETCH_SINGLE_BANK_MASTER_SUCCESS:
            return {
                ...state,
                selectedBank: updatePayload,
                loading: false,
                userform: {
                    bankName: updatePayload.fldFKBankId,
                    branchName: updatePayload.fldBranch,
                    IFSCCCode: updatePayload.fldIFSCCode,
                    MICRCode: updatePayload.fldMICRCode
                }
            };
        case UPDATE_BANK_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {},
                bankList: [],
                selectedBank: {}
            };
        case DELETE_BANK_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {},
                bankList: [],
                selectedBank: {}
            };
        case FETCH_BANK_LIST_FROM_BANK_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                bankList: updatePayload
            };
        case FETCH_BANK_MASTER_FAILURE:
        case CREATE_BANK_MASTER_FAILURE:
        case FETCH_SINGLE_BANK_MASTER_FAILURE:
        case UPDATE_BANK_MASTER_FAILURE:
        case DELETE_BANK_MASTER_FAILURE:
        case FETCH_BANK_LIST_FROM_BANK_MASTER_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_BANK_MASTER:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case BANK_MASTER_USERFORM_RESET:
            return {
                ...state,
                userform: {},
                bankList: [],
                selectedBank: {}
            };
        default:
            return state;
    }
};
